// export const LOGIN = "USERS/V4/login";
export const LOGIN = "USERS/V5/login";
export const LOGOUT = "Users/UserDeviceLogout";

export const CREATE_ACCOUNT = "users/v4/CreateAccount";
export const CREATE_NEW_ACCOUNT = "users/v3/CreateAccount";
export const UPDATE_VARIFIED_DETAILS = "Users/V1/UpdateVerifiedDetails";
export const FORGOTPASSWORD = "users/ForgotPassword";
export const ISVALIDRESETCODE = "users/IsValidResetCode";
export const RESETPASSWORD = "users/ResetPassword";
export const SEND_RESET_PASSWORD = "Account/SendResetPassword/";
export const UPDATE_RESET_PASSWORD = "Account/UpdateResetPassword";
export const GET_DASHBOARD_NOTIFICATION = "users/GetDashboardNotifications";
export const DELETE_USER_NOTIFICATIONS = "Users/DeleteUserNotificationsDismissal";
export const SAVE_USER_REFERRALS = "users/SaveUserReferrals";
export const GET_NEARBY_PLACES = "Users/GetNearbyPlaces";

export const FETCH_ADS = "Misc/FetchAds";
// Timesheet
export const FETCH_TIMESHEETS = "users/FetchTimeSheets";
export const FETCH_TIMESHEET_ENTRIES = "users/FetchTimeSheetsEntries";
export const SAVE_TIMESHEETS = "users/SaveTimeSheets";
export const SAVE_TIMESHEETS_ENTRIES = "users/SaveTimeSheetsEntries";
export const SAVE_TIMESHEETS_PICTURES = "users/SaveTimeSheetsPictures";
export const GET_TIMESHEETGOAL_DETAIL = "users/GetTimeSheetsGoalsDetailsForProgressBar";
export const FETCH_GOALS = "users/FetchGoals";
export const SAVE_GOALS = "users/SaveGoals";
export const DELETE_GOALS = "users/DeleteGoals";
export const SAVE_GOALS_CATEGORIES = "users/SaveGoalsCategories";
export const UPDATE_IS_GOAL_FLAG = "users/UpdateIsGoalFlag";
export const UPDATE_IS_TIMESHEETS_BANNER_FLAG = "users/UpdateIsTimeSheetsBannerFlag";
export const SEND_TIMESHEETS_GOALS = "users/SendTimeSheetsGoals";
export const SEND_TIMESHEETS = "users/SendTimeSheets";
export const FETCH_TIMESHEETS_GOALS = "users/FetchTimeSheetsGoals";
export const DELETE_TIMESHEETS = "users/DeleteTimesheets";
export const SAVE_TIMEHSEET_GOALS = "users/SaveTimeSheetsGoals";
export const DELETE_TIMESHEETS_GOALS = "users/DeleteTimeSheetsGoals";
export const DELETE_TIMESHEETS_PITURES = "users/DeleteTimeSheetsPictures";
export const DELETE_TIMESHEETS_ENTRIES = "users/DeleteTimeSheetsEntries";
export const DELETE_GOLE_CATEGORIES_ID = "Users/DeleteGoalsCategories";
export const USER_TIMESHEETS_CLOCK_IN_CLOCK_OUT = "users/UpdateTimesheetsClockInClockOutTime";

// New Site
export const SITE_DETAIL_TYPE = "sites/SiteDetailsByType";
export const GOOGLE_MAP_ADDRESS = "https://maps.google.com/maps/api/geocode/json?latlng=";
export const SAVE_SITES = "sites/SaveSites";
export const FETCH_SITES_PROJECTS_PICTURES = "Sites/FetchSitesProjectsPictures";
export const SAVE_SITES_PICTURES = "Sites/SaveSitesPictures";
export const SAVE_SITE_DESCRIPTION = "sites/saveSitesDescriptions";
export const FETCH_COUNTRIES = "misc/FetchCountries";
export const FETCH_SITE_TYPES = "sites/FetchSitesTypes";
export const SAVE_USER_SITES_PROJECTS = "sites/SaveUserSitesProjects";
export const FETCH_SITES_PROJECTS = "sites/FetchSitesProjects";
export const FETCH_SITES = "sites/fetchSites";
export const FETCH_SITES2 = "sites/fetchSites2";
export const FETCH_SITES_DESCRIPTIONS = "sites/FetchSitesDescriptions";
export const FETCH_SITES_COMPANY_ROLES = "sites/fetchSiteCompanyRoles";
export const DELETE_SITES = "sites/DeleteSites";
export const SITE_ISSUES = "sites/SiteIssues";
export const FETCH_NEAREST_SITE_DETAILS = "Sites/FetchNearestSiteDetails";
export const SITE_ACTIVE = "sites/SiteActiveClaims";
export const SAVE_FOLLOWING_PROJECTS = "Sites/SaveFollowingProjects";
export const SAVE_FOLLOWING_PRODUCTS = "Sites/SaveFollowingProducts";
export const FETCH_PROJECT_SITE_COMPANIES = "Sites/FetchProjectSiteCompanies";
export const SAVE_SITE_COMPANIES = "Sites/SaveSiteCompanies";
export const FETCH_PROJECT_SITE_PRODUCTS = "Sites/FetchProjectSiteProducts";
export const SAVE_SITE_PRODUCTS = "Sites/SaveSiteProducts";
export const GET_SITE_FOLLOWING_PRODUCTS = "Sites/GetSiteFollowingProducts";
export const GET_SITE_FOLLOWING_PROJECTS = "Sites/GetSiteFollowingProjects";
export const FETCH_SITES_BY_COMPANY_AND_PRODUCT = "Sites/FetchSitesByCompanyandProduct";

// Expenses
export const SAVE_EXPENSES = "users/SaveExpenses";
export const SEND_EXPENSES = "users/SendExpenses";
export const FETCH_EXPENSES = "users/FetchExpenses";
export const DELETE_EXPENSES = "users/DeleteExpenses";
export const SAVE_EXPENSES_PICTURES = "users/SaveExpensesPictures";
export const DELETE_EXPENSES_PICTURES = "users/DeleteExpensesPictures";
export const FETCH_USER_TEMP_EMAILS = "Users/FetchUserTempEmails";
export const GET_RECENTLY_USERS = "Users/GetRecentlyInteractUsers";
export const SAVE_RECENTLY_INTRACTUSERS = "Users/SaveRecentlyInteractUsers";

// TICKETS
export const FETCH_TICKETS = "tickets/FetchTickets";
export const FETCH_TICKETS_SHARED_WITH_USER = "tickets/GetTicketsSharedWithUser";
export const FETCH_TICKETS_TYPE = "tickets/FetchTicketTypes";
export const SAVE_TICKET = "tickets/SaveTicket2";
export const DELETE_TICKET = "tickets/deletetickets";
export const DELETE_TICKET_PICTURES = "tickets/DeleteTicketPictures";
export const UNSHARE_TICKET_WITH_USER1 = "tickets/UnshareTicketsWithUser1"; // post request
export const UNSHARE_TICKET_WITH_USER = "tickets/UnshareTicketsWithUser"; // get request and new one with user email and unshare owner email
export const UNSHARE_TICKET_WITH_USER_NEW = "tickets/UnshareTicketsWithUser/";
export const SEND_TICKETS = "tickets/SendTickets/";
export const SAVE_TICKET_TYPES = "tickets/SaveTicketTypes";
export const SAVE_TICKETS_SHARED_WITH_SUPERVISOR = "tickets/SaveTicketsSharedWithSupervisor";
export const FETCH_TICKETS_SHARED_WITH_SUPERVISOR = "tickets/FetchTicketsSharedWithSupervisor";
export const FETCH_TICKETSBY_USERID = "tickets/FetchTicketsbyUserId";

// Job Posting
export const FETCH_JOB_POST = "Sites/FetchJobPosts";
export const FETCH_JOB_POSTS_NEW_2 = "Sites/FetchJobPosts_New2";
export const FETCH_JOB_POST_TYPES = "Sites/FetchJobPostTypes";
export const FETCH_USERS_JOB_POSTS_DISTANCE = "sites/FetchUsersJobPostsDistance";
export const FETCH_USERS_JOB_POSTS_DISTANCE2 = "Sites/FetchUsersJobPostsDistance2";
export const FETCH_USERS_JOBS_POSTS = "sites/FetchUsersJobPosts";
export const UPDATE_EXPIRED_JOB_POSTS = "sites/UpdateExpiredJobPosts";
export const SAVE_USERS_JOB_POSTINGS = "Sites/SaveUsersJobPosts";
export const SEND_USERS_RESUME = "users/SendUserResume";
export const SAVE_JOB_POSTS = "Sites/SaveJobPosts";
export const DELETE_JOB_POSTS = "sites/deleteJobPosts";
export const FETCH_TRADES_JOBS_POSTS = "Sites/FetchTradesJobPosts";
export const SAVE_USER_USAGES = "Users/Saveuserusages";
export const GET_USER_WISE_EXPIRED_BADGE_JOBS = "Sites/GetUserWiseExpiredBadgeJobs";
export const UPDATE_VIEWS_FOR_JOB_POST = "Sites/UpdateViewsForJobPost";
export const SAVE_USERS_JOB_POSTS_NEW = "Sites/SaveUsersJobPosts_New";
export const SEND_USERS_RESUME_2 = "Users/SendUserResume2";
export const FETCH_JOB_POST_ALERTS = "Sites/FetchJobPostsAlerts_New";
export const DELETE_JOB_POST_ALERT = "Sites/DeleteJobPostsAlerts_New";
export const SAVE_JOB_POST_ALERTS = "Sites/SaveJobPostsAlerts_New";
export const FETCH_MY_JOBPOSTING = "Sites/FetchMyJobPosts_New";
export const DELETE_USER_JOBPOSTING = "Sites/DeleteJobPosts_New";
export const REPOST_USER_JOBPOSTING = "Sites/RenewExpiredJobPost";
export const SAVE_JOB_POSTS_NEW = "Sites/SaveJobPosts_New";
export const FETCH_EXTERNAL_JOBS = "AI/FetchJobSearch_Results_New2";
export const SAVE_EXTERNAL_JOB = "AI/SaveUserJobSearch_Results";
export const FETCH_EXTERNAL_JOB_ALERTS = "AI/FetchJobSearch_ResultAlerts";
export const SAVE_EXTERNAL_JOB_ALERTS = "AI/SaveJobSearch_ResultAlerts";
export const DELETE_EXTERNAL_JOB_ALERTS = "AI/DeleteJobSearch_ResultAlerts";
export const FETCH_EXTERNAL_JOB_TITLES = "AI/FetchJobSearch_JobTitles";
export const SAVE_USER_FAVORITE_JOB_POSTS = "AI/SaveUserFavoriteJobPosts";
export const DELETE_USER_FAVORITE_JOB_POSTS = "AI/DeleteUserFavoriteJobPostsByUserId";
export const FETCH_USER_FAVORITE_JOB_POSTS = "AI/FetchUserFavoriteJobPosts";
export const FETCH_JOB_SEARCH_FILTERS = "AI/FetchJobSearch_Filters";
export const SAVE_JOB_SEARCH_FILTERS = "AI/SaveJobSearch_Filters";
export const DELETE_JOB_SEARCH_FILTERS = "AI/DeleteJobSearch_Filters";
export const GET_JOB_POST_DETAILS = "AI/GetJobPostDetails";

// CARPOOL
export const GET_PEOPLE_INTEREST_IN_RIDE_SHARE = "users/GetPeopleInterestedInRideShare";
export const FETCH_USERS_COMPANIES = "users/fetchUserCompanies";
export const CHANGE_RIDE_SHARE_FOR_USER = "users/ChangeRideShareForUser";
export const SAVE_USER_ADDRESS = "users/SaveUserAddress";
export const FETCH_USERS_INTERESTED_IN_RIDESHARE_USING_POSTAL_CODE =
  "Users/FetchUsersInterestedInRideShareUsingPostalCode";
export const FETCH_CARPOOL_USER_SETTINGS = "Users/FetchCarpoolUserSettings";
export const SAVE_CARPOOL_USER_SETTINGS = "Users/SaveCarpoolUserSettings";

// TRADE
export const FETCH_USERS_TRADES = "users/fetchUserTrades";
export const DELETE_USER_TRADES = "users/DeleteUserTrades";

// USERS
export const FETCH_USERS_RESUME = "Users/FetchUsersResumes";
export const FETCH_USERS_2 = "Users/FetchUsers2";
export const FETCH_USERS_WORK_HISTORY = "users/FetchUsersWorkHistory";
export const FETCH_USERS_WORK_HISTORY2 = "users/FetchUsersWorkHistory2";
export const FETCH_PROFILE_BOARD_DATA = "Users/FetchProfileBoardData";
export const GET_USER_DASHBOARD = "users/getUserDashboard";
export const FETCH_USER_AUTH_3 = "users/FetchUserAuth3";
export const FETCH_USER_AUTH_2 = "users/FetchUserAuth2";
export const SAVE_USER_WORK_HISTORY = "Users/SaveUsersWorkHistory";
export const SAVE_USER_COMPANIES = "users/saveUserCompanies";
export const SAVE_USERS_EXPERIENCES_PRODUCTS = "Sites/SaveUsersExperiencesProducts";
export const DELTE_USER_PRODUCTS = "users/DeleteUserProducts";
export const FETCH_UNIVERSAL_SEARCH = "Users/FetchUniversalSearch";
export const SAVE_PERSONAL_INFO = "users/SavePersonalInfo";
export const GET_USER_CONTACT_STATUS_NAME = "users/getUserContactStatusName";
export const GET_ALL_TRADES_USING_USER_ID = "Misc/GetAllTradesUsingUserId";

//Builder Network
export const GET_USER_CONTACTS = "users/GetUserContacts";
export const GETUSERINFO = "users/GetUserInfo";
export const SAVECONTACTEVENT = "users/SaveContactEvent";
export const SEARCHUSERSMEMBERS = "users/searchUsersMembers";
export const SEARCH_USERS_MEMBERS_V2 = "Users/SearchUsersMembers2";

export const INVITEFRIENDSBYEMAIL = "users/inviteFriendsByEmail";
export const GET_CHAT_GROUP_DASHBOARD = "chatGroups/GetChatGroupDashboard";

// Buy-Sell
export const FETCH_BUY_SELL_USER_ITEMS_DISTANCE_NEW = "BuySell/FetchBuySellUserItemsDistanceNew";
export const FETCH_BUY_SELL_USER_ITEMS_DISTANCE = "BuySell/FetchBuySellUserItemsDistance";
export const FETCH_BUY_SELL_USER_ITEMS = "BuySell/FetchBuySellUserItems2";
export const FETCH_BUY_SELL_USER_ITEMS_V1 = "BuySell/FetchBuySellUserItems";
export const DELETE_BUY_SELL_USER_ITEMS = "BuySell/DeleteBuySellUserItems";
export const UPDATE_BUY_SELL_USER_ITEM_FOR_REPOST = "BuySell/UpdateBuySellUserItemsForRepost";
export const UPDATE_EXPIRED_ITEMS = "BuySell/UpdateExpiredItems";
export const DELETE_BUY_SELL_USER_ITEM_PICTURES = "BuySell/DeleteBuySellUserItemPictures";
export const BUY_SELL_SAVE_USER_ITEM = "BuySell/SaveUserItem";
export const BUY_SELL_SAVE_USER_ITEM_PICTURE = "BuySell/SaveUserItemPicture2";

// Dashboard
export const GET_POSTS_NEWSFEED = "posts/GetPostsNewsFeed";
export const POSTS_USER_SETTINGS = "posts/postsUserSettings";
export const GET_POST_COMMENTS = "posts/GetPostComments";
export const Save_Post_Comment = "posts/SavePostComment";
export const GET_POSTS = "posts/getPosts"; //get all pinned(appId === 19) posts for modal
export const FETCH_POST = "Posts/FetchPosts"; //for get single post by appId
export const FETCH_DASHBOARD_DATA = "Users/FetchDashboardData"; //for get single post by appId
export const FETCH_USER_SUGGETION_LIST = "Users/GetUserConnectionSuggestionList"; //for get user suggestion
export const GET_POST_ADS = "Posts/GetPostAds";
export const DELETE_POSTS_PICTURES = "Posts/DeletePostsPictures";
export const GET_POSTS_AFTER_ID = "Posts/GetPostsAfterId";
export const RAG_ASK = "Rag/ask";
export const RAG_FETCH_CHATBOT_HISTORY_ID_DETAILS = "Rag/FetchChatBotHistoryIdDetails";
export const RAG_FETCH_CHATBOT_HISTORY = "Rag/FetchChatBotHistory";
export const RAG_SAVE_CHATBOT_HISTORY_ID_DETAILS = "Rag/SaveChatBotHistoryIdDetails";
export const FETCH_POST_IDS = "Posts/FetchPostIds";
export const ANALYZE_IMAGE = "users/analyzeImage";

// Profile
export const FETCH_USER_PRODUCTS = "users/fetchUserProducts";
export const DELETE_USER_PRODUCTS = "users/DeleteUserProducts";
export const DELETE_USERS_WORKHISTORY = "users/DeleteUsersWorkHistory";
export const SAVE_EXPERIENCES_PRODUCTS = "Sites/SaveUsersExperiencesProducts";
export const SAVE_USER_CERTIFICATION = "users/SaveUserTradeCertification";
export const DELETE_USER_CERTIFICATION = "users/DeleteUserTradeCertifications";
export const IS_VALID_EMAIL_RESET_CODE = "users/isValidUserEmailResetCode";
export const SEND_USER_VERIFICATION_EMAIL = "Users/SendUserVerificationMail";
export const IS_VALID_PHONE_RESET_CODE = "users/isValidUserPhoneResetCode";
export const SEND_SMS_TO_USER_PHONE = "users/SendSMSToUserPhone/";
export const DELETE_USER_EMAILS = "users/DeleteUserEmails";
export const SAVE_USERE_MAILS = "users/SaveUserEmails";
export const DELETE_USER_PHONES = "users/DeleteUserPhones";
export const SAVE_USER_PHONES = "users/SaveUserPhones/";
export const GET_COMMON_PROJECTS = "Projects/GetCommonProjects/";

// Resume Builder
export const FETCH_USERS_RESUMES = "users/FetchUsersResumes";
export const DELETE_USERS_RESUMES = "users/DeleteUsersResumes";
export const GET_RECENTLY_INTERACT_USERS = "users/GetRecentlyInteractUsers";
export const SAVE_RECENTLY_INTERACT_USERS = "users/SaveRecentlyInteractUsers";
export const SEND_RESUME = "users/SendResume";
export const SEARCH_USERS_MEMBERS = "users/searchUsersMembers";
export const SEARCH_USERS_MEMBERS2 = "Users/SearchUsersMembers2";
export const FETCH_USER_COMPANIES = "users/fetchUserCompanies";
export const FETCH_USER_TRADES = "users/fetchUserTrades";
export const FETCH_USER_TRADE_CERTIFICATION = "users/FetchUserTradeCertifications2";
export const FETCH_USER_EMAILS = "users/FetchUserEmails2";
export const FETCH_USER_PHONES = "users/FetchUserPhones2";
export const GENERATE_RESUME = "users/GenerateResume2";
export const GET_USERS_CONTACT = "users/GetUserContacts";
export const SAVE_USERS_RESUMES = "users/saveUsersResumes";
export const SEARCH_USERS_CONTACT = "users/getusercontacts";

// Companies
export const SAVE_COMPANIES = "companies/SaveCompanies2";
export const SAVE_ROLE = "misc/SaveRole";
export const DELETE_USER_COMPANIES = "users/deleteUserCompanies";

//Reward
export const FETCH_STORE_ITEMS = "store/FetchStoreItems";
export const USER_REWARD_AMOUNT = "users/GetUserRewardAmount";
export const GET_USER_ADDRESS = "users/GetUserAddress";
export const GET_USER_STORE_ITEMS = "store/GetUserStoreItems";
export const SAVE_USER_PURCHASES = "store/saveUserPurchases";
export const GET_USER_REWARD_ACTIVITIES = "users/GetUserRewardActivities2";
export const GET_NEW_QUESTION_FOR_THE_USER = "Users/GetNewQuestionForTheUser2/";
export const FETCH_REWARD_ACTIVITIES = "misc/fetchRewardActivities";
export const FETCH_USER_QUIZZES = "Users/FetchUserQuizzes";
export const SAVE_SITE_COMPANY = "sites/SaveSiteCompany";
export const SAVE_PRODUCTS = "misc/saveProducts";
export const SAVE_USER_QUIZ_ANSWERS = "users/saveUserQuizAnswers";
export const GET_DAILY_CHALLENGES_QUIZ = "Users/GetDailyChallangesQuizForTheUser/";
export const GET_DAILY_CHALLENGE_SUMMARY = "Users/GetDailyChallengeSummaryForTheUser/";
export const UPDATE_QUESTIONS_MAYBE_LATER = "Users/UpdateQuestionsMaybelater";
export const FETCH_USER_REWARD_ACTIVITIES = "users/FetchUserRewardActivities";
export const FETCH_PRODUCTS = "misc/fetchProducts";
export const FETCH_MANUFACTURER_PRODUCTS = "Manufacturer/FetchProducts";
export const FETCH_ROLES = "misc/FetchRoles";
export const FETCH_USER_SITES_PROJECTS = "sites/FetchUserSitesProjects";
export const FETCH_TICKET_TYPES = "tickets/FetchTicketTypes";
export const GET_BUILDING_TYPES = "projects/GetBuildingTypes";
export const FETCH_PROJECT_COMPANY_ROLES = "Projects/FetchProjectCompanyRoles";

// FetchProvinces
export const FETCH_PROVINCES = "misc/FetchProvinces/";

// Posts
export const SAVE_POST_COMMENT = "posts/SavePostComment";
export const SAVE_POSTS = "posts/saveposts/";
export const SAVE_POST_PICTURE = "posts/savepostpicture";
export const SAVE_POST_VIDEOS = "posts/savepostsvideos";
export const FETCH_POST_PICTURES = "projects/FetchProjectsPostsPictures";
export const SAVE_POSTS_USERS = "posts/SavePostsUsers";
export const GET_POSTS_BY_ID = "Posts/GetPostsById ";
export const GET_SITES_POSTS_BY_ID = "Posts/GetSitesPostsById";

//Compaines
export const FETCH_COMPANIES = "companies/FetchCompanies";
export const FETCH_COMPANIES_BY_NAME = "Companies/FetchCompaniesByName";
export const FETCH_COMPANIES_BY_NAME_NEW = "Companies/FetchCompaniesByNameNew";
export const FETCH_COMPANIES_2 = "Companies/FetchCompanies2";
export const FETCH_COMPANIES_WITH_FOLLOW_STATUS = "Companies/FetchCompaniesWithFollowStatus";
export const FETCH_COMPANIES_TRADES = "companies/FetchCompanyTrades/";
export const FETCH_COMPANIES_ADDRESSES = "companies/FetchCompanyAddresses/";
export const FETCH_COMPANIES_PRODUCTS = "companies/FetchCompanyProducts/";
export const SAVE_COMPANIES_TRADES = "companies/SaveCompanyTrades";
export const SAVE_COMPANIES_ADDRESS = "companies/SaveCompanyAddresses2";
export const SAVE_COMPANY_PRODUCT = "companies/SaveCompanyProducts";
export const FETCH_SITE_COMPANIES_2 = "Sites/FetchSiteCompanies2";
export const GET_FOLLOW_COMPANIES = "Sites/GetFollowCompanies";
export const FETCH_JOB_SEARCH_RESULTS_NEW = "AI/FetchJobSearch_Results_New2";

// Manufactures
export const SEARCH_MANUFACTURES = "companies/SearchManufacturers/";
export const GET_PRODUCT_GROUPED_BY_MANUFACTUERE = "manufacturer/getProductGroupsByManufacturer/";
export const FETCH_PRODUCT_PROPERTIES = "manufacturer/FetchProductProperties/";

//Products
export const SEARCH_PRODUCTS = "misc/SearchProducts/";
export const SAVE_TRADE_PRODUCTS = "misc/saveTradeProducts";
export const FETCH_TRADE_PRODUCTS = "misc/fetchTradeProducts/";
export const FETCH_PRODUCTS_POSTS_PICTURES = "misc/FetchProductsPostsPictures";
export const FETCH_PRODUCTS_FAVOURITE_IMAGES = "misc/FetchProductsFavouriteImages";
export const DELETE_TRADE_PRODUCT = "Misc/DeleteTradeProducts2/";
export const GET_PRODUCT_MEMBERS = "users/getProductMembers/";
export const FETCH_PRODUCT_RATINGS = "misc/fetchProductRatings/";
export const SAVE_PRODUCT_RATINGS = "misc/saveProductRatings/";
export const DELETE_PRODUCTS_FAVOURITE_IMAGES = "misc/DeleteProductsFavouriteImages";
export const SAVE_PRODUCTS_FAVOURITE_IMAGES = "misc/SaveProductsFavouriteImages";
export const FETCH_SITE_PRODUCTS = "Sites/FetchSiteProducts";
export const FETCHPRODUCTDOCUMENTS = "Misc/FetchUsersDocuments";
export const SAVE_USER_DOCUMENTS = "Misc/SaveUsersDocuments";

//Trades
export const SEARCH_TRADES = "misc/searchTrades";
export const SAVE_TRADES = "misc/SaveTrades";
export const DELETE_COMPANY_TRADE = "Companies/DeleteCompanyTrades2/";
export const FETCH_TRADES = "misc/fetchTrades";
export const GET_TRADE_MEMBERS = "users/getTradeMembers";
export const GET_USER_TRADES_EXPERIENCES = "users/GetUserTradesExperiences";
export const SAVE_TRADE_NAMES = "misc/SaveTradeNames/";
export const FETCH_TRADE_NAMES = "misc/FetchTradeNames/";
export const FETCH_RELATED_TRADES = "misc/FetchRelatedTrades";
export const DELTE_USER_TRADES = "users/DeleteUserTrades/";
export const SAVE_USER_TRADES = "users/SaveUserTrades";

//Projects
export const FETCH_PROJECTS_COMPANIES = "Projects/FetchProjectCompanies2";
export const GET_PROJECT_COMPANY_ROLES = "Projects/getProjectCompanyRoles/0/0/0";
export const FETCH_PROJECTS_PICTURES = "projects/FetchProjectPictures";
export const FETCH_PROJECTS_FAVOURITE_IMAGES = "projects/FetchProjectsFavouriteImages";
export const FETCH_PROJECT_MEMBERS = "projects/getProjectMembers";
export const DELETE_PROJECTS_FAVOURITE_IMAGES = "projects/DeleteProjectsFavouriteImages";
export const SAVE_PROJECTS_FAVOURITE_IMAGES = "projects/SaveProjectsFavouriteImages";
export const SAVE_PROJECTS_COMPAINES = "projects/SaveProjectCompanies";
export const FETCH_PROJECTS_PRODUCTS = "projects/fetchProjectProducts/";
export const SAVE_PROJECTS_PRODUCTS = "projects/saveProjectProducts/";

// Follow
export const FETCH_FOLLOW_ENTITIES = "misc/fetchFollowEntities/";
export const SAVE_FOLLOW_ENTITIES = "misc/saveFollowEntities/";

//Montages
export const GET_MONTAGES = "misc/getMontagesv1";
export const GET_MONTAGES_SINGLE = "Misc/GetMontage";
export const DELETE_MONTAGES = "/misc/deleteMontage/";
export const DELETE_MONTAGES_FILE = "/misc/deleteMontageFile/";
export const GET_MUSICE = "misc/getmusicfilesv1";
export const GET_PRODUCT_IMAGES = "Projects/GetUserProjectPictures";
export const SAVE_MONTAGE = "misc/saveMontage";
export const SAVE_MONTAGE_FILE = "misc/saveMontageFile";
export const SAVE_SITE_MONTAGE_FILES = "Misc/SaveSitesMontageFiles";
export const SEND_MONTAGE = "Misc/SendMontage/";
export const FETCH_MONTAGES = "Misc/FetchMontages";

//Report
export const SAVE_DATA_ISSUES = "users/saveDataIssues/";
export const FETCH_DATA_ISSUES = "Users/FetchDataIssues";

// Setting
export const DEACTIVATE_USER_ACCOUNT = "users/DeactivateUserAccount";
export const FETCH_USER_SETTINGS = "users/FetchUserSettings";
export const UPDATE_NOTIFICATION_SETTINGS = "notification/UpdateUserNotifySettings";

// Background Notifications
export const UPDATE_NOTIFICATION_STATUS = "notification/UpdateNotificationStatus";

//Survey
export const GET_SURVEY_DATE_NEVER = "Users/GetUserSurveyListDate";
export const GET_SURVEY_DATE = "Users/GetDashboardNotificationsCount";
export const GET_SURVEY_QUIZ = "Users/FetchBIQuiz";
export const SAVE_SURVEY_ANSWERS = "Users/SaveSurveyQuestions";

/**************** Client Modules API Path  ***************************/

// Client Invitation

export const CLIENT_SAVE_INVITATIONS = "Client/Client_SaveInvitations";
export const FETCH_CLIENT_APPLIST = "Client/FetchClientAppList2";
export const FETCH_CLIENTS = "Client/FetchClients2";

export const CHECK_IF_COMPANY_HAS_CLIENT = "Companies/CheckIfCompanyHasClient";
export const GET_USER_CLIENTS_ADMIN_LIST = "Users/GetUserClientsAdminList";

export const FETCH_CLIENTS_EMPLOYEES = "Client/FetchClientEmployees2";
export const FETCH_CLIENTS_EMPLOYEES_V2 = "Client/FetchClientEmployees2";
export const DELETE_CLIENT_EMPLOYEES = "Client/DeleteClientEmployees";

export const CLIENT_USE_LICENSES = "Client/ClientUseLicenses";
export const CLIENT_DETAILS_BY_USERID = "Client/GetClientDetailsbyUserId";
export const CLIENT_DETAILS_BY_USERID_NEW = "Client/GetClientDetailsbyUserId_New";
export const CLIENT_DETAILS_BY_USEREMAIL = "Client/GetClientDetailsbyUserEmail";

// CLIENT DASHBOARD

export const FETCH_CLIENT_EMPLOYEE_LICENSES2 = "Client/FetchClientEmployeeLicenses2";
export const GET_CLIENT_EMPLOYEE_DETAILS = "Client/GetClientEmployeeLicensesDetails";
export const GET_CLIENT_EMPLOYEE_APPS_LICENSES_DETAILS =
  "Client/GetClientEmployeeAppsLicensesDetails";
export const GET_CLIENT_APPROVED_PICTUREBOARD = "Client/GetClientApprovedPictureBoard/";
export const GET_CLIENT_APP_LIST_COUNT_DETAILS = "Client/GetClientAppListCountDetails/";
export const GET_CLIENT_DASHBOARD_NOTIFICATIONS = "Client/GetClientDashboardNotifications/";
export const GET_DASHBOARD_NOTIFICATION_COUNT = "Client/GetClientDashboardNotificationsCount/";
export const GET_DASHBOARD_NOTIFICATION_COUNT_BY_USER_ID =
  "ChatGroups/Client/GetChatGroupUserWiseUnreadMessages/";

export const GET_USER_DETAILS_FOR_PROGRESS_BAR = "Users/GetUserProfileDetailsForProgressBar";

export const POST_DISMISS_PROGRESS_BAR = "Users/UpdateProgressBarDismiss";

export const UPDATE_EMPLOYEE_LICENSES_IS_PING_FLAG = "Client/UpdateEmployeeLicensesIsPinFlag";
export const UPDATE_CLIENT_EMPLOYEES_INFO = "Client/UpdateClientEmployeesInfo";

// CLIENT PICTUREBOARD

export const FETCH_CLIENT_PICTUREBOARD_V2 = "Client/FetchClientPicturesBoard2/";
export const FETCH_CLIENT_PICTUREBOARD = "Client/FetchClientPicturesBoard/";

export const FETCH_CLIENT_ASSET_CATEGORIES = "Client/FetchClientAssetCategories";
export const FETCH_CLIENT_ASSET_SUB_CATEGORIES = "Client/FetchClientAssetSubCategories";
export const SAVE_CLIENT_FIXED_ASSETS = "Client/SaveClientFixedAssets";

export const CLIENT_ANALYZE_ASSET_IMAGE = "Client/AnalyzeAssetImage";

export const FETCH_CLIENT_FIXED_ASSET_STATUS_TYPES = "Client/FetchClientFixedAssetStatusTypes2";
export const FETCH_CLIENT_FIXED_ASSETS_LIST = "Client/FetchClientFixedAssets2";
export const SAVE_CLIENT_FIXED_ASSET = "Client/SaveClientFixedAssets";
export const SAVE_CLIENT_FIXED_ASSET_STATUSES = "Client/SaveClientFixedAssetStatuses";
export const FETCH_CLIENT_FIXED_ASSET_STATUSES = "Client/FetchClientFixedAssetStatuses";
export const FETCH_CLIENT_FIXED_ASSET_PICTURES = "Client/FetchClientFixedAssetPictures2";
export const SAVE_CLIENT_FIXED_ASSET_PICTURES = "Client/SaveClientFixedAssetPictures";
export const FETCH_CLIENT_PICTUREBOARD_ALBUMS_V2 = "Client/FetchClientBoardAlbums2/";
export const SAVE_CLIENT_PICTUREBOARD = "Client/SaveClientPicturesBoard/";

// CLIENT SUPPORT
export const FETCH_CLIENT_SUPPORT = "Client/FetchClientSupports";
export const FETCH_CLIENT_SUPPORT_2 = "Client/FetchClientSupports2";
export const SAVE_CLIENT_SUPPORT = "Client/SaveClientSupports";
export const SAVE_CLIENT_SUPPORT_PICTURE = "Client/SaveClientSupportsPictures";
export const FETCH_CLIENT_SUPPORT_URGENCY_LIST = "Client/FetchClientUrgencySupportList";
export const FETCH_CLIENT_SUPPORT_CATEGORIES = "Client/FetchClientSupportCategories";
export const FETCH_CLIENT_SUPPORT_HISTORY = "Client/FetchClientSupportsHistory";
export const FETCH_CLIENT_SUPPORT_HISTORY_V2 = "Client/FetchClientSupportsHistory2";
export const SAVE_CLIENT_SUPPORT_HISTORY = "Client/SaveClientSupportsHistory";

// CLIENT SAFETY INCIDENT
export const FETCH_CLIENT_SAFETY_INCIDENT = "Client/FetchClientSafetyIncidents";
export const FETCH_CLIENT_SAFETY_INCIDENT2 = "Client/FetchClientSafetyIncidents2";
export const SAVE_CLIENT_SAFETY_INCIDENT = "Client/SaveClientSafetyIncidents";
export const FETCH_CLIENT_JOBS = "Client/FetchClientJobs/";
export const SAVE_CLIENT_EMPLOYEES = "Client/SaveClientEmployees";
export const SEND_CLIENT_INVITATION = "/Client/SendClientInvitation";
export const FETCH_CLIENT_EMPLOYEES = "Client/FetchClientEmployees";
export const FETCH_CLIENT_EMPLOYEES_JOBS = "Client/FetchClientEmployeesJobs";
export const FETCH_CLIENT_JOBS_LIST = "Client/FetchClientJobs";
export const FETCH_CLIENT_JOB_ACTIVITIES = "Client/FetchClientJobActivities";
export const SAVE_CLIENT_JOBS = "Client/saveClientJobs";
export const SAVE_CLIENT_JOB_ACTIVITIES = "Client/saveClientJobActivities";
export const DELETE_CLIENT_JOB_ACTIVITIES = "Client/DeleteClientJobActivities";
// export const SAVE_CLIENT_EMPLOYEES_JOBS = "Client/SaveClientEmployeesJobs";
export const DELETE_CLIENT_EMPLOYEES_JOBS = "Client/DeleteClientEmployeesJobs";

export const FETCH_CLIENT_UD_FIELDS_BY_CLIENT_ID = "Client/GetClientUDFieldsbyClientId/";
export const FETCH_CLIENT_UD_FIELDS_NEW2 = "Client/FetchClientUDFields_New2";
export const SAVE_CLIENT_UD_FIELDS_VALUES = "Client/SaveClientUDFieldsValues";

// CLIENT COACHING
export const FETCH_CLIENT_COACHING = "Client/FetchClientCoachings/";
export const SAVE_CLIENT_COACHING = "Client/SaveClientCoachings/";
export const FETCH_CLIENT_EMPLOYEE_V2 = "Client/FetchClientEmployeesForIndividualTimesheets";
export const FETCH_CLIENT_EMPLOYEE_FOR_TIMESHEET = "Client/FetchClientEmployeesForTimesheets";


// CLIENT COMMUNICATOR
export const FETCH_CLIENT_COMMUNICATOR_TAGS_BY_EMPLOYEES =
  "Client/FetchClientCommunicatorTagsByEmployees/";
export const GET_CLIENT_COMMUNICATOR_DETAIL = "Client/GetClientCommunicatorDetails/";
export const SAVE_CLIENT_TIMESHEETS_NEW = "Client/SaveClientTimesheets_NewManual";
export const SAVE_CLIENT_TIMESHEETS_NEW_CREW = "Client/SaveClientTimesheetsCrew_Final";
export const SAVE_CLIENT_COMMUNICATOR_ACKNOWLEDGEMENTS =
  "/Client/SaveClientCommunicatorAcknowledgements/";

// Client Timesheet
export const GET_CLIENT_TIMESHEET_DASHBOARD = "Client/GetClientTimesheetDashboard";
export const FETCH_INDIVIDUAL_CLIENT_TIMESHEETS_NEW = "Client/FetchIndividualClientTimesheets_New";
export const FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT = "Client/FetchClientJobsForIndividualTimesheets";
export const FETCH_CLIENT_JOBS_ACTIVITIES = "Client/FetchClientJobActivities2";
export const DELETE_TIMESHEET_JOBS = "Client/DeleteClientTimesheetJobs";
export const FETCH_CLIENT_TIMESHEETS_TO_APPROVE = "Client/GetClientTimesheetToApproveDetails";
export const FETCH_CLIENT_TIMESHEETS_V2 = "Client/FetchClientTimesheets2";
export const SAVE_CLIENT_TIMESHEETS = "Client/SaveClientTimesheets";
export const DELETE_CLIENT_TIMESHEETS = "/Client/DeleteClientTimesheets";
export const DELETE_CLIENT_TIMESHEET_JOBS = "Client/DeleteClientTimesheetJobs";
export const FETCH_CLIENT_TIMESHEET_TEMPLATES_V2 = "Client/FetchClientTimesheetTemplates2";
export const FETCH_CLIENT_TIMESHEET_TEMPLATES_V2_NEW = "Client/FetchClientTimesheetTemplates2New"
export const SAVE_CLIENT_TIMESHEET_TEMPLATE = "Client/SaveClientTimesheetTemplates";
export const DELETE_CLIENT_TIMESHEET_TEMPLATES = "Client/DeleteClientTimesheetTemplates";
export const FETCH_CLIENT_JOB_ACTIVITIES_V2 = "Client/FetchClientJobActivities2";
export const DELETE_CLIENT_TIMESHEET_TEMPLATE_ACTIVITIES =
  "Client/DeleteClientTimesheetTemplateActivities";
export const FETCH_CLIENT_TIMESHEET_JOBS_V2 = "Client/FetchClientTimesheetJobs2";
export const FETCH_CLIENT_TIMESHEET_JOBS_V2_NEW = "Client/FetchClientTimesheetJobs2_New";
export const DELETE_CLIENT_TIMESHEET_TEMPLATE_EMPLOYEES =
  "Client/DeleteClientTimesheetTemplateEmployees";
export const SAVE_CLIENT_TIMESHEET_JOB_IMAGES = "Client/SaveClientTimesheetJobImages";
export const DELETE_CLIENT_TIMESHEET_JOB_IMAGES = "Client/DeleteClientTimesheetJobImages";
export const GET_CLIENT_UD_FIELDS_BY_CLIENT_ID = "Client/GetClientUDFieldsbyClientId/";
export const UPDATE_CLOCK_TIME = "Client/UpdateClientCrewClockInTime";
export const FETCH_CLIENTTIMESHEET_HOURS = "Client/FetchClientTimesheetHours2";
export const SAVE_CLIENT_TIMESHEETS_JOBS_EMPLOYEE_SIGNATURES =
  "Client/SaveClientTimesheetJobsEmployeesSignatures";
export const FETCH_CLIENT_CREWFORMAN_TIMESHEETS = "Client/FetchClientCrewForemanTimesheets";
export const FETCH_CLIENT_TIMESHEETJOBS_ACTIVITIES_EMPLOYEE =
  "Client/FetchClientTimesheetJobsActivitiesEmployees";
export const UPDATE_CLIENT_CREW_CLOCKINTIME = "Client/UpdateClientCrewClockInTime";
export const UPDATE_CLIENT_TIMESHEET_HOUR_NOTES = "Client/UpdateClientTimesheetHourNotes";

// Client Expenses
export const FETCH_CLIENT_EXPENSES = "Client/FetchClientExpenses/";
export const FETCH_CLIENT_EXPENSES_HISTORY_V2 = "Client/FetchClientExpensesHistory2";
export const DELETE_CLIENT_EXPENSES = "Client/DeleteClientExpenses";
export const SAVE_CLIENT_EXPENSES = "Client/SaveClientExpenses";
export const FETCH_CLIENT_EXPENSE_CODES = "Client/FetchClientExpenseCodes2";
export const FETCH_CLIENT_CURRENCIES_V2 = "Client/FetchClientCurrencies2";
export const SAVE_CLIENT_EXPENSE_RECEIPT = "Client/SaveClientExpenseReceipt";
export const DELETE_CLIENT_EXPENSES_RECEIPTS = "Client/DeleteClientExpensesReceipts";

// CLIENT TAKE FIVE
export const FETCH_CLIENT_EMP_JOBS_2 = "Client/FetchClientEmployeesJobs2";
export const FETCH_CLIENT_TAKE_5_RECORDING = "Client/FetchClientTake5";
export const SAVE_CLIENT_TAKE_5 = "Client/SaveClientTake5";
export const SAVE_CLIENT_TAKE_5_RECORDING = "Client/SaveClientTake5Recordings";
export const FETCH_CLIENT_TAKE_5_RECORDINGS = "Client/FetchClientTake5Recordings";

// CLIENT CHANGE TRACKER
export const FETCH_CLIENT_CHANGE_TRACKER = "Client/FetchClientChangeTrackers2";
export const SAVE_CLIENT_CHANGE_TRACKER = "Client/SaveClientChangeTrackers";
export const SAVE_CLIENT_CHANGE_TRACKER_PICTURES = "Client/SaveClientChangeTrackersPictures";

// CLIENT ACTIONS
export const FETCH_CLIENT_ACTIONS = "Client/FetchClientSARActions2";
export const SAVE_DUE_CLIENT_SAR_ACTION_HISTORY = `Client/SaveOverDueClientSARActionHistory`;
export const FETCH_SAR_ACTION_HISTORY_2 = "Client/FetchClientSARActionsHistory2";
export const SAVE_CLIENT_SAR_ACTIONS_HISTORY = "Client/SaveClientSARActionsHistory";

// CLIENT QUALITY CONTROL

export const FETCH_CLIENT_EMPOYEES_JOB_4 = "Client/FetchClientEmployeesJobs4";
export const FETCH_CLIENT_JOBS_PACKAGE = "Client/FetchClientJobPackages2";
export const SAVE_CLIENT_QC_JOB_PACKAGE_ITEM_ENTRIES = "Client/SaveClientQCJobsPackageItemsEntries";
export const FETCH_CLIENT_QC_PACKAGE_ITEMS2 = "Client/FetchClientQCPackageItems2";
export const FETCH_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS2 =
  "Client/FetchClientJobPackageActivityItems2";
export const SAVE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS = "Client/SaveClientJobPackageActivityItems";
export const DELETE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS =
  "Client/DeleteClientJobPackageActivityItems;";
export const FETCH_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS_IMAGES =
  "Client/FetchClientJobPackageActivityItemImages2";
export const SAVE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS_IMAGES =
  "Client/SaveClientQCJobsPackageItemsImages";
export const DELETE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS2_IMAGES =
  "Client/DeleteClientQCJobsPackageItemsImages";
export const SAVE_CLIENT_JOB_PACKAGE_ACTIVITY = "Client/SaveClientQCJobsPackageEntries";

export const FETCH_CLIENT_SAR2 = "Client/FetchClientSAR2";
export const SAVE_CLIENT_SAR = "Client/SaveClientSAR";

export const SAVE_CLIENT_SAR_ACTIONS = "Client/SaveClientSARActions";
export const SAVE_CLIENT_SAR_ACTIONS_PICTURES = "Client/SaveClientSARActionsPictures";
export const FETCH_CLIENT_SAR_NOTES2 = "Client/FetchClientSARNotes2";
export const FETCH_CLIENT_SAR_NOTES_TYPE2 = "Client/FetchClientSARNotesTypes2";
export const FETCH_CLIENT_SAR_ACTIONS = "Client/FetchClientSARActions";
export const FETCH_CLIENT_SAR_NOTES_TYPE = "Client/FetchClientSARNotesTypes";
export const SAVE_CLIENT_SAR_NOTES = "Client/SaveClientSARNotes";

// Safety OBS
export const FETCH_CLIENT_SAFETY_OBSERVATION = "Client/FetchClientSafetyObservations2/";
export const FETCH_CLIENT_EMP_JOBS = "Client/FetchClientJobs/";
export const FETCH_UD_FIELDS = `Client/GetClientUDFieldsbyClientId/`;
export const DELETE_SAFETY_OBS_PICTURE = "Client/DeleteClientSafetyObservationsPictures";
export const SAVE_CLIENT_SAFETY_OBS = "Client/SaveClientSafetyObservations/";
export const SAVE_CLIENT_SAFETY_OBS_PICTURES = "Client/SaveClientSafetyObservationsPictures/";

export const FETCH_SAR_NOTES_TYPES = "Client/FetchClientSARNotesTypes";
export const SAVE_CLIENT_NOTES = "Client/SaveClientSARNotes";
export const SAVE_CLIENT_NOTES_PICTURES = "Client/SaveClientSARNotesPictures";

// Client Site Estimates
export const FETCH_CLIENT_SITE_ESTIMATION = "Client/FetchClientSiteEstimations";
export const FETCH_CLIENT_SITE_ESTIMATION2 = "Client/FetchClientSiteEstimations2";
export const SAVE_CLIENT_SITE_ESTIMATIONS = "Client/SaveClientSiteEstimations";
export const SAVE_CLIENT_SITE_ESTIMATES_ENTRIES = "Client/SaveClientSiteEstimationsEntries";

// Client SiteFiling apis
export const FETCH_CLIENT_SITE_FILING_LIST = "Client/FetchClientSiteFilingList";
export const FETCH_CLIENT_SITE_FILING_2 = "Client/FetchClientSiteFilings2";
export const SAVE_CLIENT_SITE_FILING_FILES = "Client/V1/SaveClientSiteFilings";

//Equipment inspections
export const FETCH_CLIENT_EQUIPMENT_INSPECTION_TYPE = "Client/FetchClientEquipmentInspectionTypes2";
export const FETCH_CLIENT_EQUIPMENT_INSPECTION_FORMS =
  "Client/FetchClientEquipmentInspectionForms2";
export const SAVE_CLIENT_EQUIPMENT_INSPECTION_RESPONSES =
  "Client/SaveClientEquipmentInspectionResponses";
export const SAVE_CLIENT_EQUIPMENT_INSPECTION_RESPONSEPITURES =
  "Client/SaveClientEquipmentInspectionResponsePictures";
export const SAVE_CLIENT_EQUIPMENT_INSPECTION_FORMS = "Client/SaveClientEquipmentInspectionForms";
export const SAVE_CLIENT_EQUIPMENT_INSPECTION_ITEMS = "Client/FetchClientEquipmentInspectionItems2";

//Inspections
export const FETCH_CLIENT_INSPECTIONS_FORM_TEMPLATES_2 =
  "Client/FetchClientInspectionsFormTemplates2";
// export const FETCH_CLIENT_INSPECTION_SECTION_TEMPLATES_2 = "Client/FetchClientInspectionSectionTemplates2";
export const FETCH_CLIENT_INSPECTION_SECTION_TEMPLATES_BY_EMPLOYEES =
  "Client/FetchClientInspectionSectionTemplatesByEmployees";
export const FETCH_CLIENT_INSPECTION_QUESION_TEMPLATES_2 =
  "Client/FetchClientInspectionQuestionTemplates2";
export const FETCH_CLIENT_INSPECTION_QUESTIONS_BY_EMPLOYEES =
  "Client/FetchClientInspectionQuestionsByEmployees";
export const SAVE_CLIENT_INSPECTION_FORM_RESPONSES = "Client/SaveClientInspectionFormResponses";
export const SAVE_CLIENT_INSPECTION_FORM_RESPONSES_FOR_FILE =
  "Client/SaveClientInspectionFormResponsesForFile";
export const UPDATE_CLIENT_INSPECTION_FORM_RESPONSES = "Client/UpdateClientInspectionFormResponses";
export const DELETE_CLIENT_INSPECTION_FORM_RESPONSES = "Client/DeleteClientInspectionFormResponses";
export const FETCH_CLIENT_INSPECTION_FORM_ANSWERS_2 = "Client/FetchClientInspectionFormAnswers2";
export const FETCH_CLIENT_INSPECTION_SECTION_TEMPLATES_QUESTIONS =
  "Client/FetchClientInspectionSectionTemplatesQuestions";
export const SAVE_CLIENT_INSPECTION_FORM_ANSWERS = "Client/SaveClientInspectionFormAnswers";

// user chat

export const GET_CHAT_GROUP_MESSAGES_BY_CHATGROUP_ID =
  "ChatGroups/GetChatGroupMessagesByChatgroupId";
export const CREATE_CHAT_GROUP = "chatGroups/CreateChatGroup";
export const GET_CHAT_GROUP_MESSAGES = "ChatGroups/GetChatGroupMessages";
export const SEND_CHAT_GROUP_NOTIFICATIONS = "chatGroups/sendChatGroupNotifications";
export const GET_MY_CHAT_GROUPS_USERS = "chatGroups/GetMyChatGroupsUsers";
export const SAVE_MESSAGE_PICTURES = "chatGroups/SaveMessagePictures";
export const GET_UNREAD_MESSAGE_COUNT = "ChatGroups/GetChatGroupUnreadMessages";
export const SAVE_CHAT_GROUP_USERS = "chatGroups/SaveChatGroupUsers";
export const LEAVE_CHAT_GROUP = "chatGroups/LeaveChatGroup";
export const SAVE_CHAT_GROUP_USER_MESSAGES = "chatGroups/SaveChatGroupUserMessages";
export const SEND_CHAT_GROUP_FIREBASE_NOTIFY = "chatGroups/SendChatGroupFirebaseNotify";
export const MUTE_CHAT_GROUP = "chatGroups/MuteChatGroup";
export const AI_TRANSLATE = "AI/GetAITextTranslator";
export const SAVE_CHAT_GROUP_MASSAGES_FOR_MONTAGE = "ChatGroups/SaveChatGroupMessagesForMontage";
export const SAVE_CHAT_MEDIA_MASSAGES = "ChatGroups/SaveChatMediaMessages";
export const FETCH_TRANSLATOR_LANGUAGES = "AI/FetchTranslatorLanguages";
export const TOGGLE_USER_TRANSLATOR_MASSAGE = "Users/ToggleUserTranslateMessage";
export const SET_DEFULT_CHAT_GROUP_LANG = "AI/SetDefaultChatGroupLang";
export const GET_CHAT_GROUP_USERWISE_UNREAD_MASSGES =
  "ChatGroups/GetChatGroupUserWiseUnreadMessages";
export const MOVE_CHAT_GROUP_MESSAGES_UNREAD_TO_READ =
  "ChatGroups/MoveChatGroupMessagesUnreadToRead";
export const GET_MY_CHAT_GROUPS_USERS_BY_USER_ID = "ChatGroups/GetMyChatGroupsUsersByUserId";
export const FETCH_CHAT_GROUP_DASHBOARD = "ChatGroups/FetchChatGroupDashboard"; // new api alternative to GET_CHAT_GROUP_DASHBOARD

// Client Chat
export const GET_CHAT_GROUP_DASHBORD_CLIENT = "chatgroups/Client/GetChatGroupDashboard";
export const GET_CHAT_GROUP_MESSAGES_CLIENT = "ChatGroups/Client/GetChatGroupMessages";
export const CLIENT_SAVE_MESSAGE_PITURES = "chatGroups/Client/SaveMessagePictures";
export const CLIENT_SAVE_CHAT_MEDIA_MASSAGES = "chatGroups/Client/SaveChatMediaMessages";
export const MOVE_CLIENT_CHAT_GROUP_MESSAGES_UNREAD_TO_READ =
  "ChatGroups/Client/MoveChatGroupMessagesUnreadToRead";

export const GET_CHAT_GROUP_USERWISE_UNREAD_MASSGES_CLIENT =
  "ChatGroups/Client/GetChatGroupUserWiseUnreadMessages";
export const FETCH_CLIENT_CHAT_GROUP_PARTICIPANTS =
  "ChatGroups/Client/FetchClientChatGroupParticipants";

// Proxy Site

// company detail page
export const FETCH_COMPANY_TRADES_FOR_WEB = "companies/FetchCompanyTradesForWeb";
export const FETCH_COMPANY_ADDRESS_FOR_WEB = "companies/FetchCompanyAddressesForWeb";
export const GET_COMPANIES_DETAILS_FOR_WEB = "Companies/GetCompaniesDetailsForWeb";
export const GET_MANUFACTURER_DETAILS_FOR_WEB = "Companies/GetManufacturerDetailsForWeb";
// product detail page
export const FETCH_PRODUCTS_POSTS_PICTURES_FOR_WEB = "misc/FetchProductsPostsPicturesForWeb";
export const FETCH_TRADE_PRODUCTS_FOR_WEB = "misc/fetchTradeProductsForWeb";
export const GET_PRODUCT_DETAILS_FOR_WEB = "Misc/GetProductDetailsForWeb";
// trade detail page
export const GET_TRADE_DETAILS_FOR_WEB = "Misc/GetTradeDetailsForWeb";
export const FETCH_RELATED_TRADES_FOR_WEB = "misc/FetchRelatedTradesForWeb";
export const FETCH_TRADE_NAMES_FOR_WEB = "misc/FetchTradeNamesForWeb";
// project detail page
export const FETCH_USERS_SITES_PROJECTS_FOR_WEB = "sites/FetchUserSitesProjectsForWeb";
export const FETCH_PROJECTS_POSTS_PICTURES_FOR_WEB = "projects/FetchProjectsPostsPicturesForWeb";

// work buddy
export const FETCH_WORK_BUDDIES = "Users/FetchWorkBuddies2";
export const UPDATE_IS_REVERIFIED_WORKBUDDY = "Users/UpdateIsReverifiedWorkBuddy2";
export const UPDATE_IS_VERIFIED_WORKBUDDY = "Users/UpdateIsVerifiedWorkBuddy";
export const VERIFY_WORKBUDDY_INVITATION = "Users/UpdateIsVerifiedWorkBuddy";

// client Videos
export const FETCH_CLIENT_VIDEOS = "Client/FetchClientVideos";
export const FETCH_CLIENT_VIDEOS_V2 = "Client/FetchClientVideos2";
export const FETCH_CLIENT_CATEGORIES = "Client/FetchClientVideoCategories2";
export const FETCH_CLIENT_TUTORIAL_VIDEOS_CATEGORIES = "Users/FetchTutorialVideosCategories";
export const FETCH_TUTORIAL_VIDEOS = "Users/FetchTutorialVideos2";
export const FETCH_TUTORIAL_VIDEOS_CATEGORIES = "Users/FetchTutorialVideosCategories";

export const VISIBILITY_SCOPES = {
  BI_FREE: "BI_FREE",
  BI_CLIENT: "BI_CLIENT",
  BI_BOTH: "BI_BOTH"
};

// Onboarding Process / SignUp
export const SAVE_ONBOARDING_USER_EXPERIENCE = "Sites/SaveOnBoardingUserExperience";
export const FETCH_ONBOARDING_USER_EMAILS_EXISTS = "Users/FetchOnBoardingForUserEmailsExists";

// Multilanguage
export const GET_APP_LABELS_LANGUAGES_DETAILS = "AI/GetAppLabelsLanguagesDetails";

// client workPackage
export const FETCH_CLIENT_WORK_PACKAGE = "Client/FetchClientWorkPackages";
export const FETCH_WORK_PACKAGES_FILES = "Client/FetchClientWorkPackageFiles2";
export const GET_CLIENT_WORK_PACKAGE_STATUSES = "Client/GetClientWorkPackageStatuses/";
export const FETCH_CLIENT_WORK_PACKAGE_TRACKING_STATUS =
  "Client/FetchClientWorkPackageTrackingStatus";
export const FETCH_CLIENT_WORK_PACKAGE_ACTIVITIES_TRACKING_STATUS =
  "Client/FetchClientWorkPackageActivitiesTrackingStatus";
export const UPDATE_CLIENT_WORK_PACKAGE_ACTIVITIES_TIMESHEETS =
  "Client/UpdateClientWorkPackageActivitiesTimesheets";
export const SAVE_CLIENT_WORK_PACKAGES_TIMESHEETS = "Client/SaveClientWorkPackagesTimesheets";
export const SAVE_CLIENT_EMPLOYEES_JOBS = "Client/SaveClientEmployeesJobs";
export const FETCH_CLIENT_WORK_PACKAGE_CURRENT_TIMESHEETS =
  "Client/FetchClientWorkPackageCurrentTimesheets";

export const GET_ANNOUNCEMENTS = "Users/GetAnnouncements";

export const FETCH_COMPANY_MERGE_MAPPING = "Companies/FetchCompanyMergeMapping";
export const FETCH_CURRENT_COMPANY_MERGE_MAPPING = "Companies/FetchCurrentCompanyMergeMapping";
export const FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW = "Client/FetchClientTimesheetUDFields_New";
export const FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT_NEW = "Client/FetchClientJobsForIndividualTimesheets_New";